import createDynamicAction from '../createDispatcher';
import createDynamicHandler from '../createHandler';
import CRUDClient from '../../client';

// For now, find a generative way to do this from crudConfig
const actionSubject = 'INPUT_NODE';
const functionSubject = 'InputNode';

export const INSERT_SUCCESS = `INSERT_${actionSubject}_SUCCESS`;
export const INSERT_FAILURE = `INSERT_${actionSubject}_FAILURE`;
export const UPDATEONE_SUCCESS = `UPDATEONE_${actionSubject}_SUCCESS`;
export const UPDATEONE_FAILURE = `UPDATEONE_${actionSubject}_FAILURE`;
export const UPDATEONE_LOCAL_SUCCESS = `UPDATEONE_LOCAL_${actionSubject}_SUCCESS`;
export const UPDATEONE_LOCAL_FAILURE = `UPDATEONE_LOCAL_${actionSubject}_FAILURE`;
export const SAVE_DEFERRED_UPDATES_SUCCESS = `SAVE_DEFERRED_UPDATES_${actionSubject}_SUCCESS`;
export const SAVE_DEFERRED_UPDATES_FAILURE = `SAVE_DEFERRED_UPDATES_${actionSubject}_FAILURE`;
export const FETCH_ALL_SUCCESS = `FETCH_ALL_${actionSubject}_SUCCESS`;
export const FETCH_ALL_FAILURE = `FETCH_ALL_${actionSubject}_FAILURE`;
export const FETCH_ONE_SUCCESS = `FETCH_ONE_${actionSubject}_SUCCESS`;
export const FETCH_ONE_FAILURE = `FETCH_ONE_${actionSubject}_FAILURE`;
export const DELETE_SUCCESS = `DELETE_${actionSubject}_SUCCESS`;
export const DELETE_FAILURE = `DELETE_${actionSubject}_FAILURE`;

export const commonTypes = {
    INSERT_FAILURE,
    INSERT_SUCCESS,
    UPDATEONE_FAILURE,
    UPDATEONE_SUCCESS,
    UPDATEONE_LOCAL_FAILURE,
    UPDATEONE_LOCAL_SUCCESS,
    SAVE_DEFERRED_UPDATES_SUCCESS,
    SAVE_DEFERRED_UPDATES_FAILURE,
    FETCH_ALL_FAILURE,
    FETCH_ALL_SUCCESS,
    FETCH_ONE_FAILURE,
    FETCH_ONE_SUCCESS,
    DELETE_FAILURE,
    DELETE_SUCCESS
};


//TODO: Add update/delete local
export const dispatchers = {
    insert: (status) => {
        return {
            success: createDynamicAction(`insert${functionSubject}`, INSERT_SUCCESS),
            failure: createDynamicAction(`insert${functionSubject}`, INSERT_FAILURE),
        }[status];
    },
    update: (status) => {
        return {
            success: createDynamicAction(`update${functionSubject}`, UPDATEONE_SUCCESS),
            failure: createDynamicAction(`update${functionSubject}`, UPDATEONE_FAILURE),
        }[status];
    },
    updateLocal: (status) => {
        return {
            success: createDynamicAction(`update${functionSubject}Local`, UPDATEONE_LOCAL_SUCCESS),
            failure: createDynamicAction(`update${functionSubject}Local`, UPDATEONE_LOCAL_FAILURE),
        }[status];
    },
    saveDeferredUpdates: (status) => {
        return {
            success: createDynamicAction(`saveDeferred${functionSubject}Updates`, SAVE_DEFERRED_UPDATES_SUCCESS),
            failure: createDynamicAction(`saveDeferred${functionSubject}Updates`, SAVE_DEFERRED_UPDATES_FAILURE),
        }[status];
    },
    fetchAll: (status) => {
        return {
            success: createDynamicAction(`insert${functionSubject}`, FETCH_ALL_SUCCESS),
            failure: createDynamicAction(`insert${functionSubject}`, FETCH_ALL_FAILURE),
        }[status];
    },
    fetchOne: (status) => {
        return {
            success: createDynamicAction(`insert${functionSubject}`, FETCH_ONE_SUCCESS),
            failure: createDynamicAction(`insert${functionSubject}`, FETCH_ONE_FAILURE),
        }[status];
    },
    delete: (status) => {
        return {
            success: createDynamicAction(`insert${functionSubject}`, DELETE_SUCCESS),
            failure: createDynamicAction(`insert${functionSubject}`, DELETE_FAILURE),
        }[status];
    },
};


const NodeActions = (crudConfig = null) => {
    if (crudConfig === null) {
        return {
            insert: createDynamicHandler(`insert${functionSubject}`, () => Promise.reject('Crud Config not provided'), dispatchers.insert, primaryKey),
            update: createDynamicHandler(`update${functionSubject}`, () => Promise.reject('Crud Config not provided'), dispatchers.update, primaryKey),
            updateLocal: createDynamicHandler(`update${functionSubject}Local`, (k, update) => Promise.resolve(update), dispatchers.updateLocal, primaryKey),
            saveDeferredUpdates: createDynamicHandler(`saveDeferred${functionSubject}Updates`, () => Promise.reject('Crud Config not provided'), dispatchers.saveDeferredUpdates, primaryKey),
            fetchAll: createDynamicHandler(`fetchAll${functionSubject}`, () => Promise.reject('Crud Config not provided'), dispatchers.fetchAll, primaryKey),
            fetchOne: createDynamicHandler(`fetchOne${functionSubject}`, () => Promise.reject('Crud Config not provided'), dispatchers.fetchOne, primaryKey),
            delete: createDynamicHandler(`delete${functionSubject}`, () => Promise.reject('Crud Config not provided'), dispatchers.delete, primaryKey),

        }
    } else {
        const Client = CRUDClient(crudConfig);

        let primaryKey = typeof crudConfig.primaryKey === 'string' ? crudConfig.primaryKey : 'uuid';

        return {
            insert: createDynamicHandler(`insert${functionSubject}`, Client.insert, dispatchers.insert, primaryKey),
            update: createDynamicHandler(`update${functionSubject}`, Client.update, dispatchers.update, primaryKey),
            updateLocal: createDynamicHandler(`update${functionSubject}Local`, (k, update) => Promise.resolve(update), dispatchers.updateLocal, primaryKey),
            saveDeferredUpdates: createDynamicHandler(`saveDeferred${functionSubject}Updates`, Client.updateMany, dispatchers.saveDeferredUpdates, primaryKey),
            fetchAll: createDynamicHandler(`fetchAll${functionSubject}`, Client.fetchAll, dispatchers.fetchAll, primaryKey),
            fetchOne: createDynamicHandler(`fetchOne${functionSubject}`, Client.fetchOne, dispatchers.fetchOne, primaryKey),
            delete: createDynamicHandler(`delete${functionSubject}`, Client.delete, dispatchers.delete, primaryKey),
        }
    }
};

export default NodeActions;

